import React from 'react';
import SubjectAnalyticsBody from './SubjectProfile';

const SubjectAnalytics = () => {
    return (
        <div className="min-h-screen min-w-screen">
            <SubjectAnalyticsBody />
        </div>
    );
}

export default SubjectAnalytics;